import { useEffect } from "react";
import { exitChatPage, enterChatPage } from "../store/features/chatSlice";
import { useDispatch } from "react-redux";

/***
 * Because the way Olark works we can not render olark component here in the chat page.
 * The Olark React components should be rendered only once in the app and 
 * does not support unmount and remount again.
 * 
 * So the InlineOlark component is rendered in the App component.
 * In this page we only modify the chat state int he redux to indicate if the user is in the Chat page or not.
 */
export default function Chat() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(enterChatPage());

    return () => {
      dispatch(exitChatPage());
    };
  }, [dispatch]);

  return null;
}
